import React from 'react';
import Icon from 'scenes/V2/Shared/LocationDetails/RequiredCredentials/cred-icon.svg';
import StudentHatIcon from '../assets/student-hat.png';
import FootballIcon from '../assets/football.png';
import IndustrialIcon from '../assets/industrial-icon.png';
import './ProfileView.scss';

const ProfileView = ({ image, name, address, jobsWorked }) => {
  return (
    <div className="profileView">
      <div className="profileView-header">
        <div className="profileView-header-left">
          <img src={image} alt={name} />
        </div>
        <div className="profileView-header-right">
          <div className="profileView-header-top">
            <div className="profileView-name-section">
              <div className="profileView-header-right-name">{name.split(' ').join(', ')}</div>
              <div className="at-address-location">{address}</div>
            </div>
            <div className="at-worked-jobs">
              <span className="gotham-medium-font text-wrap">{jobsWorked}</span>
            </div>
          </div>
          <div className="profileView-reliability-score">
            Reliability Score:
            <span className="reliability-score-number">100%</span>
          </div>
        </div>
      </div>
      <div className="profileView-body">
        <div className="experience">
          <div className="experience-item-name">Experience</div>
          <div className="experience-item">
            <img src={StudentHatIcon} alt="Schools" />
            <span>Schools</span>
          </div>
          <div className="experience-item">
            <img src={FootballIcon} alt="Sports" />
            <span>Sports</span>
          </div>
          <div className="experience-item">
            <img src={IndustrialIcon} alt="Industrial" />
            <span>Industrial</span>
          </div>
        </div>
        <div className="credential">
          <div className="credential-item-name">Credentials</div>
          <div className="credential-item">
            <img src={Icon} alt="Board Certification" />
            <span>Board Certification</span>
          </div>
          <div className="credential-item">
            <img src={Icon} alt="State License" />
            <span>State Licensure</span>
          </div>
          <div className="credential-item">
            <img src={Icon} alt="Liability Insurance" />
            <span>Liability Insurance</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileView;
